import React from "react";
import { Modal } from "components/modal/modal";
import { ModalSize } from "components/modal/modal.types";
import { ClassRating } from "constants/rate-classes";

import { IRateClassModalProps } from "./rate-class-modal.types";
import RateClassRatingForm from "./rate-class-rating-form";
import RateClassDetailedForm from "./rate-class-detailed-form";
import RateClassSubmitted from "./rate-class-submitted";
import { RatingFormStep } from "hooks/use-rate-class-modal/use-rate-class-modal.types";
import { useRateClassModal } from "hooks/use-rate-class-modal/use-rate-class-modal";

const RateClassModal: React.FC<IRateClassModalProps> = ({
  onClose,
  data,
  primaryUser,
  metaData
}) => {
  const {
    selectedRating,
    step,
    handleDetailedFormSkip,
    handleDetailedFormSubmit,
    handleRatingFormSubmit,
    handleRatingFormSkip
  } = useRateClassModal({
    initialRating: data.rating || null,
    primaryUser,
    metaData,
    data
  });

  const handleModalClose = () => {
    if (step === RatingFormStep.INITIAL_RATING) {
      handleRatingFormSkip(data.liveClass.id);
    } else if (step === RatingFormStep.DETAILED_FEEDBACK) {
      handleDetailedFormSkip();
    }
    onClose();
  };

  const renderStep = (currentStep: RatingFormStep) => {
    switch (currentStep) {
      case RatingFormStep.INITIAL_RATING: {
        return (
          <RateClassRatingForm
            initialRating={data.rating}
            data={data}
            onSubmit={handleRatingFormSubmit}
          />
        );
      }
      case RatingFormStep.DETAILED_FEEDBACK: {
        return (
          <RateClassDetailedForm
            selectedRating={selectedRating as ClassRating}
            onSubmit={handleDetailedFormSubmit}
            data={data}
            onSkip={handleDetailedFormSkip}
            metaData={metaData}
          />
        );
      }
      case RatingFormStep.SUBMITTED: {
        return (
          <RateClassSubmitted
            onClose={handleModalClose}
            selectedRating={selectedRating as ClassRating}
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  return (
    <Modal
      isOpen
      onClose={handleModalClose}
      size={ModalSize.Normal}
      closeIconProperties={{
        isHidden: step !== RatingFormStep.INITIAL_RATING
      }}
    >
      {renderStep(step)}
    </Modal>
  );
};

export default RateClassModal;
